import {
  Component,
  Renderer2,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnInit,
  ChangeDetectorRef,
  HostListener,
} from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, window } from 'rxjs/operators';
import { OpcionesPerfilRolDto } from 'src/app/core/data/OpcionesPerfilRolDto';
import { opciones } from 'src/app/core/data/rolOpciones';
import { SubjectsService } from 'src/app/core/services/subjects.service';
import { AutenticacionStoreService } from 'src/app/feature/autenticacion/store/autenticacion-store.service';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.css'],
})
export class SideBarComponent implements OnInit, AfterViewInit {
  private subs = new SubSink();
  public estado: boolean;
  public homeSeleccionado: boolean;
  public monitoreoSeleccionado: boolean;
  public empresaSeleccionado: boolean;
  public reportesSeleccionado: boolean;
  public reportesRifasSeleccionado: boolean;
  public rifasSeleccionado: boolean;
  public logoSidebar: boolean;
  public ocultoLogin = true;
  public modulo: string;
  public viewporSize: number;

  // COM Marcar Item
  public selectMonitoreo: boolean;
  public selectEmpresa: boolean;
  public selectReportes: boolean;
  public selectrifas: boolean;

  // COM Modulos
  public moduloInicio: boolean;
  public selectinicio: boolean;
  public boletasVendidas: boolean;
  public boletasGanadoras: boolean;
  public boletasAnuladas: boolean;
  public adminCorreos: boolean;
  public registroRifas: boolean;
  public registroSorteos: boolean;
  public numerosJugados: boolean;
  public detalleSucursales: boolean;
  public ventaLoteriaOtros: boolean;
  public reportePremios: boolean;
  public reporteAnulados: boolean;

  public pathRedireccion;

  public perfiles$: Observable<OpcionesPerfilRolDto>;
  public perfiles: OpcionesPerfilRolDto;
  public constantesOpciones = opciones;

  @ViewChild('animationMenu') animationMenu?: ElementRef;
  // COM Monitoreo
  @ViewChild('monitoreo') monitoreo?: ElementRef;
  @ViewChild('itemMonitoreo') itemMonitoreo?: ElementRef;
  @ViewChild('empresa') empresa?: ElementRef;
  @ViewChild('itemEmpresa') itemEmpresa?: ElementRef;
  @ViewChild('reportes') reportes?: ElementRef;
  @ViewChild('itemReportes') itemReportes?: ElementRef;
  @ViewChild('subitemReporteRifas') subitemReporteRifas?: ElementRef;
  @ViewChild('rifas') rifas?: ElementRef;
  @ViewChild('itemRifas') itemRifas?: ElementRef;
  @ViewChild('ventaLoteriaOtrosProductos')
  ventaLoteriaOtrosProductos?: ElementRef;

  constructor(
    private subjectService: SubjectsService,
    private readonly renderer: Renderer2,
    private readonly cdr: ChangeDetectorRef,
    private router: Router,
    private autenticacionStoreService: AutenticacionStoreService
  ) {
    this.perfiles$ = this.autenticacionStoreService.obtenerPerfiles$();
    this.perfiles = new OpcionesPerfilRolDto();
  }

  ngAfterViewInit(): void {
    this.ocultarSidebarLogin();
    this.verificarEstadoSideBar();
    this.cdr.detectChanges();
    this.removerItemActivo();
    this.añadirItemActivo();
  }

  ngOnInit(): void {
    this.subjectService.hideSidebarNavbarGet.subscribe(resp => {
      const hideSidebar = resp ? this.ocultoLogin = true : this.ocultoLogin = false;
    });
    this.ocultarSidebarLogin();
    this.cdr.detectChanges();
  }

  public verificarEstadoSideBar(): void {
    this.subjectService.resolucionPantalla.subscribe(resp => {
      this.viewporSize = resp;
      if(this.viewporSize < 800){
        const removerHover = this.animationMenu.nativeElement;
        removerHover.style.transition = 'none';
      }
    });
    this.subs.add(
      this.subjectService.listadoRecursosAside.subscribe((estado: boolean) => {
        this.subjectService.iconSidebarGet.subscribe(resp => this.logoSidebar = resp ? true : false);
        this.estado = estado;
        if (this.estado) {
          this.cerrarModulos();
          this.renderer.addClass(
            this.animationMenu.nativeElement,
            'closeSidebar'
          );
          this.cerrarModulos();
        }
        if (!this.estado) {
          this.renderer.removeClass(
            this.animationMenu.nativeElement,
            'closeSidebar'
          );
          this.validarItemADescubrir();
        }
        if(this.viewporSize <= 768 && this.selectinicio && estado){
          this.renderer.addClass(this.animationMenu.nativeElement, 'closeSidebarTouch');
        }
        else {
          this.renderer.removeClass(this.animationMenu.nativeElement, 'closeSidebarTouch');
        }
      })
      );
  }

  abrirSubitem(subitem: string): void {
      this.subjectService.moveIconNavSet = true;
      this.logoSidebar = true;
      this.selectinicio = false;
      if(this.viewporSize <= 768){
        this.renderer.removeClass(this.animationMenu.nativeElement, 'closeSidebarTouch');
        this.renderer.removeClass(this.animationMenu.nativeElement, 'closeSidebar');
      }
      if (subitem === 'reportesRifas') {
        this.abrirReportesRifas();
      } else {
        switch (subitem) {
          case 'monitoreo':
            this.abrirMonitoreo();
            break;
          case 'empresa':
            this.abrirEmpresas();
            break;
          case 'reportes':
            this.abrirReportes();
            break;
          case 'rifas':
            this.abrirRifas();
            break;
        }
    }
  }

  public redireccionamiento(item: string) {
    switch (item) {
      case 'inicio':
        this.selectinicio = true;
        this.router.navigate(['inicio/home']);
        break;
      case 'numerosjugados':
        this.router.navigate(['monitoreo/numeros-mas-jugados']);
        break;
      case 'detallesucursales':
        this.router.navigate(['monitoreo/detalle-sucursales']);
        break;
      case 'administradorcorreo':
        this.router.navigate(['reporte/administrador-correo']);
        break;
      case 'reportesVentas':
        if(this.perfiles['INFORME VENTA BANCA RECARGAS POR VENDEDOR']){
          this.router.navigate(['reporte/venta-loterias-y-otros-productos']);
        }else if(this.perfiles['REPORTE VENTAS QUINTE']){
          this.router.navigate(['reporte/ventas-quinte']);
        }
        break;
      case 'reportesPremios':
        this.router.navigate(['reporte/premios-quinte']);
        break;
      case 'reportesAnulados':
        this.router.navigate(['reporte/anulados-quinte']);
        break;
      case 'boletasvendidas':
        this.router.navigate(['reporte/boletas-vendidas']);
        break;
      case 'boletasganadoras':
        this.router.navigate(['reporte/boletas-ganadoras']);
        break;
      case 'boletasanuladas':
        this.router.navigate(['reporte/boletas-anuladas']);
        break;
      case 'registrorifas':
        this.router.navigate(['rifas/registro-rifas']);
        break;
      case 'registrosorteos':
        this.router.navigate(['rifas/registro-sorteo']);
        break;
    }

    this.subjectService.listadoRecursosAsideData = this.viewporSize < 1100 ? true : false;
  }

  public añadirItemActivo(): void {
    this.subjectService.pathVistaToSideBarGet.subscribe({
      next: (path: string) => {
        this.pathRedireccion = path;
        this.cerrarModulos();
        this.removerItemActivo();
        this.removerModuloItem();
        this.validarItemADescubrir().then(resp => {
          switch (this.pathRedireccion) {
            case 'inicio':
              this.moduloInicio = true;
              break;
            case 'mensajeria':
              this.cerrarModulos();
              this.removerItemActivo();
              this.removerModuloItem();
              break;
            case 'numerosJugados':
              this.numerosJugados = true;
              this.selectMonitoreo = true;
              break;
            case 'detalleSucursales':
                this.detalleSucursales = true;
                this.selectMonitoreo = true;
              break;
            case 'administradorCorreos':
              this.adminCorreos = true;
              this.selectEmpresa = true;
              break;
            case 'ventaLoteriaOtrosProductos':
              this.ventaLoteriaOtros = true;
              this.selectReportes = true;
              break;
            case 'ventasQuinte':
              this.ventaLoteriaOtros = true;
              this.selectReportes = true;
              break;
            case 'premiosQuinte':
              this.reportePremios = true;
              this.selectReportes = true;
              break;
            case 'anuladosQuinte':
              this.reporteAnulados = true;
              this.selectReportes = true;
              break;
            case 'boletasVendidas':
              this.boletasVendidas = true;
              this.selectReportes = true;
              break;
            case 'boletasGanadoras':
              this.boletasGanadoras = true;
              this.selectReportes = true;
              break;
            case 'boletasAnuladas':
              this.boletasAnuladas = true;
              this.selectReportes = true;
              break;
            case 'rifas':
              this.registroRifas = true;
              this.selectrifas = true;
              break;
            case 'sorteos':
              this.registroSorteos = true;
              this.selectrifas = true;
              break;
          }
          this.verificarEstadoSideBar();
        });
      },
    });
  }

  validarItemADescubrir(): Promise<boolean> {
    return new Promise(res => {
      this.subjectService.iconSidebarGet.subscribe(resp => this.logoSidebar = resp ? true : false);
      switch (this.pathRedireccion) {
        case 'numerosJugados':
          this.monitoreoSeleccionado = true;
          break;
        case 'detalleSucursales':
          this.monitoreoSeleccionado = true;
          break;
        case 'administradorCorreos':
          this.empresaSeleccionado = true;
          break;
        case 'ventaLoteriaOtrosProductos':
          this.reportesSeleccionado = true;
          break;
        case 'ventasQuinte':
          this.reportesSeleccionado = true;
          break;
        case 'premiosQuinte':
          this.reportesSeleccionado = true;
          break;
        case 'anuladosQuinte':
          this.reportesSeleccionado = true;
          break;
        case 'boletasVendidas':
          this.reportesSeleccionado = true;
          this.reportesRifasSeleccionado = true;
          break;
        case 'boletasGanadoras':
          this.reportesSeleccionado = true;
          this.reportesRifasSeleccionado = true;
          break;
        case 'boletasAnuladas':
          this.reportesSeleccionado = true;
          this.reportesRifasSeleccionado = true;
          break;
        case 'rifas':
          this.rifasSeleccionado = true;
          break;
        case 'sorteos':
          this.rifasSeleccionado = true;
          break;
      }
      if(!this.estado && this.viewporSize < 1100){
        this.cerrarModulos();
      }
      res(true);
    });
  }

  abrirMonitoreo(): Promise<boolean> {
    return new Promise(res => {
      if (this.monitoreoSeleccionado) {
        this.renderer.addClass(this.itemMonitoreo.nativeElement, 'animate__fadeOutLeft');
        setTimeout(() => {
        this.monitoreoSeleccionado = false;
        }, 800);
      } else {
        this.cerrarModulos();
        this.monitoreoSeleccionado = true;
      }
      res(true);
    });
  }
  abrirEmpresas(): Promise<boolean> {
    return new Promise(res => {
      if (this.empresaSeleccionado) {
        this.renderer.addClass(this.itemEmpresa.nativeElement, 'animate__fadeOutLeft');
        setTimeout(() => {
          this.empresaSeleccionado = false;
        }, 800);
      } else {
        this.cerrarModulos();
        this.empresaSeleccionado = true;
      }
      res(true);
    });
  }
  abrirReportes(): Promise<boolean> {
    return new Promise(res => {
      if (this.reportesSeleccionado) {
        this.renderer.addClass(this.itemReportes.nativeElement, 'animate__fadeOutLeft');
        setTimeout(() => {
          this.reportesSeleccionado = false;
        }, 800);
      } else {
        this.cerrarModulos();
        this.reportesSeleccionado = true;
      }
      res(true);
    });
  }
  abrirReportesRifas(): Promise<boolean> {
    return new Promise(res => {
      if (this.reportesRifasSeleccionado) {
        this.renderer.addClass(this.subitemReporteRifas.nativeElement, 'animate__fadeOutLeft');
        setTimeout(() => {
          this.reportesRifasSeleccionado = false;
        }, 800);
      } else {
        this.reportesRifasSeleccionado = true;
      }
      res(true);
    });
  }
  abrirRifas(): Promise<boolean> {
    return new Promise(res => {
      if (this.rifasSeleccionado) {
        this.renderer.addClass(this.itemRifas.nativeElement, 'animate__fadeOutLeft');
        setTimeout(() => {
          this.rifasSeleccionado = false;
        }, 800);
      } else {
        this.cerrarModulos();
        this.rifasSeleccionado = true;
      }
      res(true);
    });
  }

  ocultarSidebarLogin(): void {
    this.subjectService.ocultarSidebarLoginGet.subscribe(respuesta => respuesta ? this.ocultoLogin = true : this.ocultoLogin = false);
  }

  cerrarModulos(): Promise<boolean> {
    return new Promise(res => {
      this.monitoreoSeleccionado = false;
      this.empresaSeleccionado = false;
      this.reportesSeleccionado = false;
      this.reportesRifasSeleccionado = false;
      this.rifasSeleccionado = false;
    });
  }

  removerItemActivo() {

    this.moduloInicio = false;
    this.numerosJugados = false;
    this.detalleSucursales = false;
    this.adminCorreos = false;
    this.ventaLoteriaOtros = false;
    this.reportePremios = false;
    this.reporteAnulados = false;
    this.boletasVendidas = false;
    this.boletasGanadoras = false;
    this.boletasAnuladas = false;
    this.registroRifas = false;
    this.registroSorteos = false;
  }

  removerModuloItem() {
    this.selectMonitoreo = false;
    this.selectEmpresa = false;
    this.selectReportes = false;
    this.selectrifas = false;
  }

  //COM roles -----------

  public validarOpcion(valor: number): boolean {
    this.perfiles$.subscribe((data: OpcionesPerfilRolDto) => {
      this.perfiles = data;
    });

    return Object.values(this.perfiles).includes(valor);
  }
}
